import React from 'react'
import type { ConnectorProps as ListProps } from '../connectors/Collection'
import CollectionConnector from '../connectors/Collection'
import { LoadMoreButton, LoadMoreButtonRow } from './styles'
import { LOAD_MORE_TOOLTIP } from '../helpers/constants'
export default CollectionConnector((props: ListProps): React$ElementRef<any> | null => {
  const { loadMoreCollections, collectionsList, currentPage, pageTotal } = props

  if (!collectionsList.length || collectionsList.length < 28 || currentPage + 1 === pageTotal) {
    return null
  }

  return (
    <LoadMoreButtonRow>
      <LoadMoreButton title={LOAD_MORE_TOOLTIP} onClick={loadMoreCollections}>
        Load More
      </LoadMoreButton>
    </LoadMoreButtonRow>
  )
})